import { render, staticRenderFns } from "./ConvoPreviewFooter.vue?vue&type=template&id=51952274&scoped=true&"
import script from "./ConvoPreviewFooter.vue?vue&type=script&lang=js&"
export * from "./ConvoPreviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./ConvoPreviewFooter.vue?vue&type=style&index=0&id=51952274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51952274",
  null
  
)

export default component.exports